var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 1206,
    viewBox: "0 0 1440 1206",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1533.05 24.9043C665.403 171.663 38.7966 10.2947 -116.231 0L-178.243 63.8937C-419.451 237.001 -963.775 650.364 -251.253 996.938C461.269 1343.51 1606.06 1193.51 1715.08 1016.43L1925.62 799.824C1980.13 457.401 2009.63 -55.7073 1533.05 24.9043Z",
    fill: "#E4EEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.05088a00f39a346b717942fa1cb7bd31.svg";
export { ForwardRef as ReactComponent };